// The landing page's "problem → reveal" sections, in page order. Each one
// shows `problem` alongside its recording, then flips the caption to `reveal`
// once playback passes `revealAt` (seconds into the video), and flips back
// when the loop restarts.
//
// To add or re-time a recording: drop the files in frontend/public/landing/
// and edit this list -- nothing else. `revealAt` is the moment the payoff is
// visible on screen (e.g. the frame where the items finish flowing into open
// space), read off the video in any player. Until a video file exists the
// section is hidden entirely, so an entry can wait here for its recording.
//
// `webm` is optional: when present it's offered first (smaller), with the MP4
// as the fallback every browser can play.
//
// `aspectRatio` is the video's own width / height, so its frame is never
// cropped; omit it for the 16 / 10 default.

const heroSections = [
  {
    id: "flow-around",
    problem: "Want a to-do list that doesn't overlap your calendar?",
    reveal: "Then this is what you're looking for.",
    mp4: "/landing/flow-around.mp4",
    webm: null,
    poster: "/landing/flow-around.jpg",
    aspectRatio: "1224 / 1080",
    revealAt: 5.5, // items visibly flow into open time at ~5.47s
    alt: "To-do items sitting on top of calendar events, then flowing into the open time around them once flow-around is turned on.",
  },
  // Hidden until frontend/public/landing/intersection.mp4 exists.
  {
    id: "intersection",
    problem: "Want a calendar that shows where multiple calendars share open time?",
    reveal: "Then this is your calendar.",
    mp4: "/landing/intersection.mp4",
    webm: null,
    poster: "/landing/intersection.jpg",
    revealAt: 4.0,
    alt: "Several separate calendars with no shared view, then an overlay of the open time they all share once intersect is turned on for each.",
  },
];

export default heroSections;
